import React from 'react';
import * as StyleUtils from 'Utils/StyleUtils';
export function SignInButton(props) {
    return (React.createElement("button", { "aria-label": props.label, className: StyleUtils.mergeClassNames('border text-base', props.className), onClick: props.onClick },
        React.createElement("span", { className: "flex justify-center" }, props.label)));
}
